import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        type: 'light',
        primary: {
          main: '#10587f',
        },
        secondary: {
          main: '#248952',
        },
        danger: {
          main: '#DD2025',
        },
        background: {
            tab: '#dee5ea'
        }
      },
});

export default theme

// export default {
//     backgroundColor: '#dee5ea',
//     primaryText: '#3f3f3e',
//     titleColor: '#32567b'
// }